import TagTemplate from '../components/tag-template';

export default TagTemplate;
